/**
 * TeamsPage Messages
 *
 * This contains all the text for the TeamsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.teams';

export default defineMessages({
  teams: {
    id: `${scope}.teams`,
    defaultMessage: 'Teams',
  },
  newTeam: {
    id: `${scope}.newTeam`,
    defaultMessage: 'New Team',
  },
});
